import { render } from "./PortalHomeLayout.vue?vue&type=template&id=20ab1f61&scoped=true"
import script from "./PortalHomeLayout.vue?vue&type=script&lang=js"
export * from "./PortalHomeLayout.vue?vue&type=script&lang=js"

import "./PortalHomeLayout.vue?vue&type=style&index=0&id=20ab1f61&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ab1f61"]])

export default __exports__